import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import { Flex } from '@mantine/core';
import React, { memo } from 'react';
import styled from 'styled-components';

interface Props {
	title: string | React.ReactNode;
	tooltip?: string;
	children?: React.ReactNode;
}

const TextPair = ({ title, children }: Props) => {
	return (
		<Flex direction="column" style={{ whiteSpace: 'pre-line' }}>
			<TitleText>{title}</TitleText>
			<ContentWrapper>{children}</ContentWrapper>
		</Flex>
	);
};

export const ContentWrapper = styled.div`
	display: flex;
	align-items: center;
`;
const TitleText = styled(TextV2).attrs({
	variant: 'sans/11/400',
})`
	color: ${({ theme }) => theme.v2.color.neutral[500]};
`;
export const ContentText = styled(TextV2)`
	color: ${({ theme }) => theme.v2.color.neutral[1100]};
`;
const _TextPairExport = memo(TextPair);

export { _TextPairExport as TextPair };
